import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c8c467"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex-container" }
const _hoisted_3 = { class: "flex-container ion-justify-content-start" }
const _hoisted_4 = { class: "ion-margin-start" }
const _hoisted_5 = { class: "flex-container ion-justify-content-start" }
const _hoisted_6 = { class: "ion-margin-start" }
const _hoisted_7 = { class: "flex-container ion-justify-content-start" }
const _hoisted_8 = { class: "ion-margin-start" }
const _hoisted_9 = { class: "flex-container ion-justify-content-start" }
const _hoisted_10 = { class: "ion-margin-start" }
const _hoisted_11 = { class: "flex-container ion-justify-content-start" }
const _hoisted_12 = { class: "ion-margin-start" }
const _hoisted_13 = { class: "flex-container ion-justify-content-start" }
const _hoisted_14 = { class: "responsive-table" }
const _hoisted_15 = { class: "no-background" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_17 = { class: "ion-text-center" }
const _hoisted_18 = { class: "ion-justify-content-center" }
const _hoisted_19 = { class: "new-row" }
const _hoisted_20 = { class: "ion-justify-content-center" }
const _hoisted_21 = { class: "flex-container ion-justify-content-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
        }, [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "equal-height-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-align-items-center ion-margin-vertical" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('ManagementCenter')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_auto_fill_select, {
                                options: _ctx.managementCenters,
                                searchField: "name",
                                selected: _ctx.data.management_center_name,
                                label: _ctx.translations[_ctx.currentLanguage].ManagementCenter,
                                placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = option => _ctx.handleSelected(option, _ctx.data, 'management_center', true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" >")
                                ]),
                                _: 1
                              }, 8, ["options", "selected", "label", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-margin-vertical ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Area')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                modelValue: _ctx.data.sau,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.sau) = $event)),
                                modelModifiers: { number: true },
                                label: _ctx.translations[_ctx.currentLanguage].SAUNotEditable,
                                readonly: true,
                                "label-placement": "floating",
                                class: "input"
                              }, null, 8, ["modelValue", "label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                modelValue: _ctx.data.irrigated_area,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.irrigated_area) = $event)),
                                modelModifiers: { number: true },
                                label: _ctx.translations[_ctx.currentLanguage].IrrigatedArea,
                                "label-placement": "floating",
                                class: "input",
                                onIonBlur: _ctx.submitForm
                              }, null, 8, ["modelValue", "label", "onIonBlur"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-margin-vertical ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('UTH')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                type: "number",
                                fill: "solid",
                                modelValue: _ctx.data.uth_number,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.uth_number) = $event)),
                                modelModifiers: { number: true },
                                label: _ctx.translations[_ctx.currentLanguage].UTHNumber,
                                "label-placement": "floating",
                                class: "input",
                                onIonBlur: _ctx.submitForm
                              }, null, 8, ["modelValue", "label", "onIonBlur"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                fill: "solid",
                                modelValue: _ctx.data.uth_number_by_employee,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.uth_number_by_employee) = $event)),
                                label: _ctx.translations[_ctx.currentLanguage].UTHNumberByEmployee,
                                "label-placement": "floating",
                                class: "input",
                                onIonBlur: _ctx.submitForm
                              }, null, 8, ["modelValue", "label", "onIonBlur"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-margin-vertical ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_ion_checkbox, {
                                  modelValue: _ctx.data.dual_activity,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.dual_activity) = $event)),
                                  onIonChange: _ctx.submitForm
                                }, null, 8, ["modelValue", "onIonChange"]),
                                _createVNode(_component_ion_text, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('DualActivity')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.data.dual_activity)
                            ? (_openBlock(), _createBlock(_component_ion_col, {
                                key: 0,
                                size: "12",
                                "size-md": "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    fill: "solid",
                                    modelValue: _ctx.data.dual_activity_type,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.dual_activity_type) = $event)),
                                    label: _ctx.translations[_ctx.currentLanguage].DualActivityType,
                                    "label-placement": "floating",
                                    class: "input",
                                    onIonBlur: _ctx.submitForm
                                  }, null, 8, ["modelValue", "label", "onIonBlur"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-justify-content-start ion-margin-vertical" }, {
                        default: _withCtx(() => [
                          (_ctx.data.bio_certification)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.checkmarkOutline,
                                      size: "medium"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('BIO')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.data.heifer_breeding_delegation)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.checkmarkOutline,
                                      size: "medium"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('HVE')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.data.short_network_sale)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.checkmarkOutline,
                                      size: "medium"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('ShortNetwork')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.data.farm_products_transfo)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 3 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.checkmarkOutline,
                                      size: "medium"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('TransfoFarmProducts')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.data.mo_employer)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.checkmarkOutline,
                                      size: "medium"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('MOEmployer')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.data.other_certifications)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 0,
                            class: "ion-justify-content-start ion-margin-vertical"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('OtherCertifications')), 1),
                                    _createVNode(_component_ion_text, { class: "ion-margin-start" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.data.other_certifications), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_row, { class: "ion-margin-vertical" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            "size-md": "auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('MAEProjects')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { class: "ion-margin-vertical" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("table", _hoisted_15, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Type')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('EngagmentDate')), 1),
                                    _hoisted_16
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.projects, (project, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_ion_input, {
                                            fill: "solid",
                                            modelValue: project.type,
                                            "onUpdate:modelValue": ($event: any) => ((project.type) = $event),
                                            "aria-label": _ctx.translations[_ctx.currentLanguage].Type,
                                            class: "input",
                                            onIonBlur: ($event: any) => (_ctx.updateProject(project))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label", "onIonBlur"])
                                        ]),
                                        _createElementVNode("td", _hoisted_17, [
                                          _createVNode(_component_ion_input, {
                                            fill: "solid",
                                            modelValue: project.date,
                                            "onUpdate:modelValue": ($event: any) => ((project.date) = $event),
                                            "aria-label": _ctx.translations[_ctx.currentLanguage].EngagmentDate,
                                            class: "input",
                                            onIonBlur: ($event: any) => (_ctx.updateProject(project))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label", "onIonBlur"])
                                        ]),
                                        _createElementVNode("td", _hoisted_18, [
                                          _createVNode(_component_ion_button, {
                                            color: "danger",
                                            onClick: ($event: any) => (_ctx.deleteProject(project.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, { icon: _ctx.trashBinOutline }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]))
                                    }), 128)),
                                    _createElementVNode("tr", _hoisted_19, [
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_ion_input, {
                                          fill: "solid",
                                          modelValue: _ctx.newProject.type,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newProject.type) = $event)),
                                          "aria-label": _ctx.translations[_ctx.currentLanguage].Type,
                                          class: "input",
                                          onIonBlur: _ctx.submitForm
                                        }, null, 8, ["modelValue", "aria-label", "onIonBlur"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_ion_input, {
                                          fill: "solid",
                                          modelValue: _ctx.newProject.date,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newProject.date) = $event)),
                                          "aria-label": _ctx.translations[_ctx.currentLanguage].EngagmentDate,
                                          class: "input",
                                          onIonBlur: _ctx.submitForm
                                        }, null, 8, ["modelValue", "aria-label", "onIonBlur"])
                                      ]),
                                      _createElementVNode("td", _hoisted_20, [
                                        _createVNode(_component_ion_button, { onClick: _ctx.addProject }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('Add')), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-margin-vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('DataProcessingText')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ion_checkbox, {
                          modelValue: _ctx.data.data_processing_agreement,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.data_processing_agreement) = $event)),
                          onIonChange: _ctx.submitForm
                        }, null, 8, ["modelValue", "onIonChange"]),
                        _createVNode(_component_ion_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('DataProcessingAgreement')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 32)
      ]))
    : _createCommentVNode("", true)
}